import {OptionTypeBase} from 'platform/components';

import {Nullish} from 'shared/web';

import {DefinitionAuthorizationProfile} from '../types/Definition';

/**
 * Builds authorization profile option label with templates count.
 */
export const getAuthorizationProfileOptionLabelWithCount = (
  option: OptionTypeBase<string | Nullish>,
  authorizationProfiles: DefinitionAuthorizationProfile[]
) => {
  const templatesCount =
    authorizationProfiles.find(
      (profile) => profile.authorizationProfile.authorizationProfileId === option.value
    )?.templates?.length ?? 0;

  return `${option.label} (${templatesCount})`;
};
